export default __webpack_public_path__ + "static/media/perso-jo.aa40a597.png";